import type { ReactNode } from "react";
import { cn } from "./cn";

export interface KeyValueItem {
  term: ReactNode;
  value: ReactNode;
}

/** A definition list: terms on the left, values on the right (stacked on small screens). */
export function KeyValue({ items, className }: { items: KeyValueItem[]; className?: string }) {
  return (
    <dl
      className={cn(
        "m-0 grid grid-cols-1 gap-x-[18px] gap-y-0.5 text-base md:grid-cols-[minmax(120px,170px)_1fr] md:gap-y-2.5",
        className,
      )}
    >
      {items.map((item, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: terms are nodes, not unique keys; the list is static
        <div key={index} className="contents">
          <dt className="text-ink-3">{item.term}</dt>
          <dd className="m-0 mb-2.5 min-w-0 [overflow-wrap:anywhere] md:mb-0">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
